import { SCAN_CLASS } from './../constants/global-constants';
import { DeviceInfoModel } from './../models/deviceInfo.model';
import { TagInfoModel } from './../models/tagInfo.model';
export function getCurrentUTCDate() {
  let today = new Date;
  return formatTwoDigitString(today.getUTCDate()) + ' ' + formatMonthString(today.getUTCMonth()) + ' ' + today.getUTCFullYear() + ' ' + formatTwoDigitString(today.getUTCHours()) + ':' + formatTwoDigitString(today.getUTCMinutes()) + ':' + formatTwoDigitString(today.getUTCSeconds()) + ' UTC';
}

export function formatTwoDigitString(num): string {
  return num.toString().length > 1 ? num : '0' + num.toString();
}

export function formatMonthString(month): string {
  let monthString = '';
  switch (month + 1) {
    case 1:
      monthString = 'Jan';
      break;
    case 2:
      monthString = 'Feb';
      break;
    case 3:
      monthString = 'Mar';
      break;
    case 4:
      monthString = 'Apr';
      break;
    case 5:
      monthString = 'May';
      break;
    case 6:
      monthString = 'June';
      break;
    case 7:
      monthString = 'July';
      break;
    case 8:
      monthString = 'Aug';
      break;
    case 9:
      monthString = 'Sept';
      break;
    case 10:
      monthString = 'Oct';
      break;
    case 11:
      monthString = 'Nov';
      break;
    case 12:
      monthString = 'Dec';
      break;
  }
  return monthString;
}

export function formatDate(dateReceived) {
  let currentDate = new Date(dateReceived.split("+")[0]);
  return formatTwoDigitString(currentDate.getDate()) + ' ' + formatMonthString(currentDate.getMonth()) + ' ' + currentDate.getFullYear() + ' ' + formatTwoDigitString(currentDate.getHours()) + ':' + formatTwoDigitString(currentDate.getMinutes()) + ':' + formatTwoDigitString(currentDate.getSeconds()) + ' UTC';
}


export const TAG_LIST: TagInfoModel[] = [
  {
    tagName: "Press Pump Intake",
    type: "ModBus",
    id: "123333",
    equipment: "Zenith Surface Panel",
    scaling: "0.1"
  },
  {
    tagName: "Power Motor Amps",
    type: "Analog",
    id: "56777777",
    equipment: "Zenith Surface Panel",
    scaling: "0.5"
  }
];

export const groupData = [
  {
    "tagName": "Press Pump Intake",
    "id": "098",
    "equipment": "Zenith Surface Panel",
    "channel": "RS232 Point1",
    "value": "677.09"
  },
  {
    "tagName": "Power Motor Amps",
    "id": "765",
    "equipment": "Equipment 66",
    "channel": "RS232 Point2",
    "value": "0999"
  },
  {
    "tagName": "Status Hz",
    "id": "860",
    "equipment": "Zenith Surface Panel",
    "channel": "Maroon",
    "value": "9888"
  },
  {
    "tagName": "Tag3",
    "id": "5677",
    "equipment": "Zenith Surface Panel",
    "channel": "RS232 Point4",
    "value": "1335"
  }
]

export function createFilterForTableSearch(data: any, filter: string, cols: string[]) {
  let matchFilter = false;
  for (let i = 0; i < cols.length; i++) {
    let dataValue = data[cols[i]];
    if (dataValue) {
      if (cols[i] == "pollingFrequency") {
        dataValue = SCAN_CLASS[dataValue];
      }
      matchFilter = matchFilter || (dataValue + "").toLowerCase().includes(filter);

    }

  }

  return matchFilter;
}

export function dateRangeDifference(startDate: Date, endDate: Date): number {
  let date1 = new Date(startDate);
  let date2 = new Date(endDate);
  // To calculate the time difference of two dates
  let Difference_In_Time = date2.getTime() - date1.getTime();   
  // To calculate the no. of days between two dates
  let Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
  return Difference_In_Days;
}

export function advantagelogdisplay(stringValue, tagName) {
  let displayValue;
  if(!stringValue) displayValue = stringValue;
  let splittedValue = (stringValue?.toString())?.split('[');
  if(splittedValue && splittedValue.length > 1) {
      let convertedValue = splittedValue
      .map(x=> x.split('['))
      .map((x,index)=> {if(index != 0) return `\n[${x}`} )
      .join(' ');
      displayValue = convertedValue;
  } else {
      displayValue = stringValue;
  }
  if(tagName != 'EVENT_LOG' || tagName != 'SHUTDOWN_LOG' && displayValue ) {
    displayValue = parseFloat(displayValue).toFixed(2);
  }
  return displayValue;
}

export function getPreviousDay(date = new Date()) {
  const previous = new Date(date.getTime());
  previous.setDate(date.getDate() - 1);

  return previous;
}

export function getLastWeeksDate() {
  const now = new Date();
  return new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
}

export function getFifteenDaysPrevious() {
  const now = new Date();
  return new Date(now.getTime() - 15 * 24 * 60 * 60 * 1000);
}

export function getPreviousMonth() {
  const current = new Date();
  return new Date(current.setMonth(current.getMonth()-1));
}

export function getPreviousYear() {
  const d = new Date();
  return new Date(d.setFullYear(d.getFullYear()-1));
}

export function getNextMinute(currentTime) {
  const nextMinute = new Date (currentTime);
  nextMinute.setMinutes(nextMinute.getMinutes() + 1);
  return nextMinute;
}

export function getNextHour(currentTime) {
  const nextHour = new Date (currentTime);
  nextHour.setHours(nextHour.getHours() + 1);
  return nextHour;
}

export function getNextDay(currentTime) {
  const nextDay = new Date (currentTime);
  nextDay.setDate(nextDay.getDate() + 1);
  return nextDay;
}

export function getSyncTime(time){
  if(time < 10){
   return "0"+time;
  }
  return time;
}

export function parseSecondsIntoReadableTime(d){
   //Get hours from milliseconds
   d = Number(d);
   var h = Math.floor(d / 3600);
   var m = Math.floor(d % 3600 / 60);
   var s = Math.floor(d % 3600 % 60);

   var hDisplay = h > 0 ? h + (h == 1 ? "hour, " : "hours, ") : "";
   var mDisplay = m > 0 ? m + (m == 1 ? "minute, " : "minutes, ") : "";
   var sDisplay = s > 0 ? s + (s == 1 ? "second" : "seconds") : "";
   return hDisplay + mDisplay + sDisplay; 
}

export function getPastHour(diff){
  var hoursBefore = new Date();
  hoursBefore.setHours(hoursBefore.getHours() - diff);
  return hoursBefore;
}

export function formatTimeOnPicker(hours, minutes){
  if(hours < 10){
    hours = "0"+hours;
  }
  if(minutes < 10){
    minutes = "0"+minutes;
  }
  var currentTime = [
    hours,
    ':',
    minutes,
  ].join('');
  return currentTime;
}